import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Output, Input, EventEmitter } from "@angular/core";
import { Observable, Subject, Subscribable } from "rxjs";
import { RegisteredSignal } from "src/app/web-api-client";

@Component({
  selector: 'app-signal-map-list-items',
  templateUrl: './signal-map-list-items.component.html',
  styleUrls: ['./signal-map-list-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignalsMapListItemsComponent {

  @Input() signalsList: RegisteredSignal[];

  @Output() signalResponse = new EventEmitter<RegisteredSignal>();

  public selectedSignal: RegisteredSignal;

  constructor(public _cdr:ChangeDetectorRef) {

  }


  public onSelectedSignal(signal: RegisteredSignal) {
    this.selectedSignal = signal;
    this.signalResponse.next(signal);

    this._cdr.detectChanges();
  }

}
